import { Component } from '@angular/core';

@Component({
  selector: 'help',
  template: require('./help.component.html'),
  styles: [require('./help.component.scss')]
})
export class HelpComponent {

  constructor() {
    // Do stuff
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/help/help.component.ts